define('bizzabo/utils',[
    'jquery',
    'underscore',
    'timezoneJS',
    'moment/moment'
], function(
    $,
    _,
    timezoneJS,
    globalMoment
) {

    var UTILS = (function() {

        var ONE_MINUTE = 1000 * 60;
        var ONE_DAY = ONE_MINUTE * 60 * 24;

        var ensureArray = function(obj) {
            return _.isUndefined(obj) ? [] : (_.isArray(obj) ? obj : [ obj ]);
        };

        /**
         * runs cb after a min delay of minDelay millis
         * @param timerStart when the clock started ticking in millis
         * @param minDelay the min delay in millis
         * @param cb the method to call after the delay
         * @param context a param for that method
         */
        var minDelay = function(timerStart, minDelay, cb, context) {
            var currentDate = new Date();
            var currentTime = currentDate.getMilliseconds();
            var timeDiff = currentTime - timerStart;
            var timeToDelay = minDelay - timeDiff;
            if (timeToDelay > 0) {
                _.delay(cb, timeToDelay, context);
            } else {
                _.delay(cb, 0, context);
            }
        };

        var getDiffInDays = function(localStartDate, localEndDate) {
            var startDate = moment(localStartDate, 'YYYY-MM-DD HH:mm').startOf('day');
            var endDate = moment(localEndDate, 'YYYY-MM-DD HH:mm').endOf('day');
            return endDate.diff(startDate, 'days');
        };

        var getDaysFrom = function(startMillis, dayIndex, timeZone) {
            var dateObject = new timezoneJS.Date(startMillis);
            dateObject.setTimezone(timeZone);
            dateObject.setTime(startMillis + (dayIndex * ONE_DAY));
            return dateObject.getTime();
        };

        var timeStringToMinutes = function(timeString) {
            if (_.isUndefined(timeString)) {
                return 0;
            }
            var parts = timeString.split(":");
            return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
        };

        var minutesToTimeString = function(minutesInt) {
            var hours = Math.floor(minutesInt / 60);
            var minutes = minutesInt % 60;
            return addLeadingZero(hours) + ":" + addLeadingZero(minutes);
        };

        var addLeadingZero = function(number) {
            if (_.isString(number) && number.length === 1) {
                number = "0" + number;
            } else if (number < 10) {
                number = "0" + number;
            }
            return number;
        };

        var durationToDetailedString = function(duration) {
            var hours = Math.floor(duration / 60);
            var minutes = duration % 60;

            if (hours > 0) {
                if (minutes < 15) {
                    return hoursToString(hours);
                }
                if (minutes < 45) {
                    return hoursToString(hours + 0.5);
                }
                return hoursToString(hours + 1);
            } else {
                return minutes + " mins";
            }
        };

        var hoursToString = function(hours) {
            var res = hours + " hr";
            if (hours > 1) {
                return res + "s";
            }
            return res;
        };

        var splitToFirstAndLastNames = function(name) {
            var res = {
                first : undefined,
                last : undefined
            };
            if (_.isUndefined(name) || !_.isString(name)) {
                return res;
            }

            name = name.trim();
            if (name.length === 0) {
                return res;
            }

            var firstSpaceIndex = name.indexOf(" ");
            if (firstSpaceIndex == -1) {
                res.first = name;
                return res;
            }
            firstSpaceIndex++;
            res.first = name.slice(0, firstSpaceIndex).trim();
            res.last = name.slice(firstSpaceIndex).trim();
            return res;
        };

        var ensureAmPmFormat = function(time24, returnUndefinedOnError) {
            var errorReturnValue = returnUndefinedOnError ? undefined : time24;
            if (_.isUndefined(time24) || (time24 + "").length === 0) {
                return errorReturnValue;
            }
            var parts = [];
            if (_.isNumber(time24)) {
                parts[0] = Math.floor(time24) + "";
                parts[1] = "00";
            } else {
                parts = time24.split(':');
                if (parts.length === 1) {
                    parts[1] = "00";
                }
                if (parts.length > 2 || parts[0].length > 4 || parts[1].length > 2) {
                    return errorReturnValue;
                }
            }

            var last2 = parts[1].substr(-2).toLowerCase();
            parts[0] = parseInt(parts[0], 10);
            if (_.isNaN(parts[0])) {
                return errorReturnValue;
            }

            if (last2 == "am" || last2 == "pm") {
                parts[2] = last2;
                parts[1] = parts[1].substr(0, parts[1].length - 2);
            } else {
                if (parts[0] > 11) {
                    parts[2] = "pm";
                    parts[0] -= 12;
                } else {
                    parts[2] = "am";
                }
            }

            if (parts[0] === 0) {
                parts[0] = 12;
            }
            return parts[0] + ":" + parts[1] + parts[2];
        };

        /**
         * return the input on error, so it will be validated by the Session model
         * @param amPm an input string/number that represents a time (hours:minutes)
         * @return amPm on error, and an hh:mm string on success
         */
        var ensure24hourFormat = function(amPm, returnUndefinedOnError) {
            var errorReturnValue = returnUndefinedOnError ? undefined : amPm;
            if (_.isUndefined(amPm)) {
                return errorReturnValue;
            }
            var parts = [];
            if (_.isNumber(amPm)) {
                parts[0] = addLeadingZero(Math.floor(amPm));
                parts[1] = "00";
                return parts[0] + ":" + parts[1];
            }
            if (!_.isString(amPm) || amPm.length === 0) {
                return errorReturnValue;
            }

            var end = undefined;
            if (amPm.length > 1) {
                var last2 = amPm.slice(-2).toLowerCase();
                if (last2 == "am" || last2 == "pm") {
                    end = last2;
                    amPm = amPm.substr(0, amPm.length - 2);
                }
            }

            parts = amPm.split(":");
            if (parts.length === 1) {
                parts[1] = "00";
            }
            if (parts.length > 2 || parts[0].length > 4 || parts[1].length > 2) {
                return errorReturnValue;
            }
            parts[0] = parseInt(parts[0], 10);
            if (_.isNaN(parts[0])) {
                return errorReturnValue;
            }

            if (end == "pm" && parts[0] < 12) {
                parts[0] += 12;
            }
            if (parts[0] == 12 && end == "am") {
                parts[0] = 0;
            }

            return addLeadingZero(parts[0]) + ":" + parts[1];
        };

        /*
         Mixes mixin into me, while me's functions override mixin's functions
         */
        var mixIntoMe = function(me, mixin) {
            var newMixin = _.extend({}, mixin, me);
            _.extend(me, newMixin);
        };

        String.prototype.toCamel = function() {
            return this.replace(/(\-[a-z])/g, function($1) {
                return $1.toUpperCase().replace('-', '');
            });
        };

        var getExtremeModel = function(collection, attr, isMin) {
            var extremeModel = _.first(collection.models);
            var extremeValue = extremeModel.get(attr);
            for (var i = 0; i < collection.length; i++) {
                var thisModel = collection.at(i);
                var thisAttr = thisModel.get(attr);
                var isBigger = thisAttr > extremeValue;
                if ((isMin && (!isBigger)) || ((!isMin) && isBigger)) {
                    extremeValue = thisAttr;
                    extremeModel = thisModel;
                }
            }
            return extremeModel;
        };

        var removeAllSubViewsInArray = function(arr) {
            _.each(arr, function(subView) {
                subView && _.isFunction(subView.remove) && subView.remove();
            });
            return [];
        };

        var removeAllSubViewsInMap = function(map) {
            return removeAllSubViewsInArray(_.values(map));
        };

        var getViewOffsetFromTop = function(view) {
            return view.$el.offset().top;
        };

        /**
         * Returns the query parameters substring without the fragment and without the question sign
         * @param url The url to process
         * @return {String}
         */
        var getQueryParamsSubString = function(url) {
            return subStringBetween(url, "?", "#");
        };

        /**
         * Returns the fragment without the query params and without the hash
         * @param url The url to process
         * @return {String}
         */
        var getFragmentSubString = function(url) {
            return subStringBetween(url, "#", "?");
        };

        var subStringBetween = function(url, charStart, charEnd) {
            var questionMarkIndex = url.indexOf(charStart);
            if (questionMarkIndex < 0) {
                return;
            }

            var res = url.substr(questionMarkIndex + 1);
            var hashIndex = res.indexOf(charEnd);
            if (hashIndex > 0) {
                res = res.substr(0, hashIndex);
            }
            return res;
        };

        var summarize = function(arr) {
            if (!arr) {
                return undefined;
            }

            var sum = 0;
            return _.map(arr, function(num) {
                sum += num;
                return sum;
            });
        };

        var prependZeros = function(arr, l) {
            if (arr && arr.length < l) {
                while (arr.unshift(0) < l) {
                }
            }
        };

        var getNumberWithCommas = function(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };

        var leafCount = function(obj) {
            if (_.isUndefined(obj)) {
                return 0;
            }
            if (!_.isObject(obj)) {
                return 1;
            }
            return _.reduce(obj, function(memo, item) {
                return memo + leafCount(item);
            }, 0);
        };

        var UI = {

            scrollMainPage : function(top) {
                $("html:not(:animated),body:not(:animated)").animate({
                    scrollTop : top || 0
                }, 500);
            },

            selectAll : function(element) {
                if (!element) {
                    return;
                }
                var $el = $(element);
                setTimeout(function() {
                    $el.select();
                }, 1);
                // Work around Chrome's little problem
                $el.mouseup(function() {
                    $el.unbind('mouseup');
                    return false;
                });
            },

           focusOnField : function(focusField) {
                var focusFieldValue = focusField.val();
                focusField.focus();
                _.defer(function() {
                    focusField.val('');
                    focusField.val(focusFieldValue);
                });
            }

        };

        var unfoldAttribute = function(attrs, attrToUnfold) {
            if (attrs[attrToUnfold]) {
                var prefix = attrToUnfold + '-';
                _.each(attrs[attrToUnfold], function(value, key) {
                    attrs[prefix + key] = value;
                });
                delete attrs[attrToUnfold];
            }
            return attrs;
        };

        var numberWithCommas = function(x) {
            if (x == undefined){
                return "0";
            }
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };

        var applyRecursively = function(obj, func) {
            if (!_.isObject(obj) && !_.isArray(obj)) {
                return;
            }
            _.each(obj, function(value, key) {
                func(obj, value, key);
                applyRecursively(value, func);
            }, this);
        };

        // Public object ----------------------------------------

        return {
            UI : UI,
            ensureArray : ensureArray,
            minDelay : minDelay,
            getDiffInDays : getDiffInDays,
            getDaysFrom : getDaysFrom,
            timeStringToMinutes : timeStringToMinutes,
            minutesToTimeString : minutesToTimeString,
            durationToDetailedString : durationToDetailedString,
            splitToFirstAndLastNames : splitToFirstAndLastNames,
            ensureAmPmFormat : ensureAmPmFormat,
            ensure24hourFormat : ensure24hourFormat,
            mixIntoMe : mixIntoMe,
            getExtremeModel : getExtremeModel,
            removeAllSubViewsInMap : removeAllSubViewsInMap,
            removeAllSubViewsInArray : removeAllSubViewsInArray,
            getViewOffsetFromTop : getViewOffsetFromTop,
            getQueryParamsSubString : getQueryParamsSubString,
            getFragmentSubString : getFragmentSubString,
            summarize : summarize,
            prependZeros : prependZeros,
            getNumberWithCommas : getNumberWithCommas,
            leafCount : leafCount,
            unfoldAttribute : unfoldAttribute,
            numberWithCommas : numberWithCommas,
            applyRecursively : applyRecursively
        };
    })();

    return UTILS;

});
